import { useState, useEffect } from "react";
import { useGetAllTrainersQuery } from "src/services/TrainerServices";

const useTrainers = () => {
  const [trainers, setTrainers] = useState<any[]>([]);
  const [isDataLoading, setIsDataLoading] = useState(true);

  const { data, isLoading, isFetching } = useGetAllTrainersQuery("");

  useEffect(() => {
    if (isLoading || isFetching) {
      setIsDataLoading(true);
    } else {
      const result: any[] = data?.data;
      setTrainers(result || []);
      setIsDataLoading(false);
    }
  }, [data, isLoading, isFetching]);

  return { trainers, isDataLoading };
};

export default useTrainers;
